// client/src/components/ofertas/FiltroOfertas.js - VERSÃO 100% PADRONIZADA
import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Search, X, Filter, Loader2 } from 'lucide-react';

const initialFilterState = {
    nome: '',
    tipo: '',
    ativo: '',
    tipoDePrecificacao: '',
    agendavel: ''
};

const FiltroOfertas = ({ onApplyFilters, loading }) => {
    const [localFilters, setLocalFilters] = useState(initialFilterState);

    const onChange = useCallback(e => {
        const { name, value, type, checked } = e.target;
        let filterValue;
        
        if (name === 'ativo' || name === 'agendavel') {
            if (value === "true") filterValue = true;
            else if (value === "false") filterValue = false;
            else filterValue = '';
        } else {
             filterValue = type === 'checkbox' ? checked : value;
        }

        setLocalFilters(prev => ({ ...prev, [name]: filterValue }));
    }, []);

    const onSubmit = useCallback(e => {
        e.preventDefault();
        if (onApplyFilters) {
            const activeFilters = Object.fromEntries(
                Object.entries(localFilters).filter(([_, v]) => v !== '' && v !== null)
            );
            onApplyFilters(activeFilters);
        }
    }, [localFilters, onApplyFilters]);

    const handleClearFilters = useCallback(() => {
        setLocalFilters(initialFilterState);
        if (onApplyFilters) {
            onApplyFilters({});
        }
    }, [onApplyFilters]);

    const isAnyFilterActive = useMemo(() => {
        return Object.values(localFilters).some(v => v !== '');
    }, [localFilters]);

    return (
        <form onSubmit={onSubmit} className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 items-end">

                {/* 1. Nome da Oferta */}
                <div className="flex flex-col gap-1 md:col-span-2 lg:col-span-1 xl:col-span-2">
                    <label htmlFor="filter-nome-oferta" className="text-xs font-semibold text-gray-600 uppercase">Nome da Oferta</label>
                    <input
                        type="text"
                        name="nome"
                        id="filter-nome-oferta"
                        placeholder="Buscar por nome..."
                        value={localFilters.nome}
                        onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                        disabled={loading}
                    />
                </div>

                {/* 2. Tipo de Oferta */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-tipo-oferta" className="text-xs font-semibold text-gray-600 uppercase">Tipo</label>
                    <select
                        name="tipo"
                        id="filter-tipo-oferta"
                        value={localFilters.tipo}
                        onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                        disabled={loading}
                    >
                        <option value="">Todos</option>
                        <option value="Individual">Individual</option>
                        <option value="Pacote">Pacote</option>
                        <option value="Combo">Combo</option>
                    </select>
                </div>

                {/* 3. Status */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-ativo-oferta" className="text-xs font-semibold text-gray-600 uppercase">Status</label>
                    <select
                        name="ativo"
                        id="filter-ativo-oferta"
                        value={localFilters.ativo}
                        onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                        disabled={loading}
                    >
                        <option value="">Todos</option>
                        <option value="true">Ativa</option>
                        <option value="false">Inativa</option>
                    </select>
                </div>

                {/* 4. Precificação */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-precificacao-oferta" className="text-xs font-semibold text-gray-600 uppercase">Precificação</label>
                    <select
                        name="tipoDePrecificacao"
                        id="filter-precificacao-oferta"
                        value={localFilters.tipoDePrecificacao}
                        onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                        disabled={loading}
                    >
                        <option value="">Todas</option>
                        <option value="Fixo">Fixo</option>
                        <option value="Por Pacote">Por Pacote</option>
                        <option value="Sob Consulta">Sob Consulta</option>
                        <option value="A Partir de">A Partir de</option>
                    </select>
                </div>

                {/* 5. Agendável? */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-agendavel-oferta" className="text-xs font-semibold text-gray-600 uppercase">Agendável?</label>
                    <select
                        name="agendavel"
                        id="filter-agendavel-oferta"
                        value={localFilters.agendavel}
                        onChange={onChange}
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                        disabled={loading}
                    >
                        <option value="">Indiferente</option>
                        <option value="true">Sim</option>
                        <option value="false">Não</option>
                    </select>
                </div>

                {/* Botões de Ação — antes reinventava cor do zero em Tailwind
                    (bg-blue-600, borda vermelha custom) */}
                <div className="flex gap-2 h-full items-end md:col-span-2 lg:col-span-3 xl:col-span-6 justify-end mt-2">
                    {isAnyFilterActive && (
                        <button
                            type="button"
                            onClick={handleClearFilters}
                            className="action-button action-button-secondary"
                            disabled={loading}
                        >
                            <X size={18} className="icon"/> Limpar
                        </button>
                    )}
                    <button
                        type="submit"
                        className="action-button action-button-primary"
                        disabled={loading}
                    >
                        {loading ? <Loader2 size={18} className="icon animate-spin" /> : <Search size={18} className="icon" />}
                        Aplicar Filtros
                    </button>
                </div>

            </div>

            {/* Resumo de Filtros */}
            {isAnyFilterActive && (
                <div className="mt-4 pt-3 border-t border-gray-200 flex items-center justify-between text-xs text-gray-500">
                    <div className="flex items-center gap-2">
                        <Filter size={14} className="text-blue-600" />
                        <span>Filtros ativos:</span>
                        <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full font-medium">
                            {Object.values(localFilters).filter(v => v !== '').length}
                        </span>
                    </div>
                </div>
            )}
        </form>
    );
};

FiltroOfertas.propTypes = {
    onApplyFilters: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default FiltroOfertas;